<div class="layout-content">
  <router-outlet></router-outlet>
</div>
